export default __webpack_public_path__ + "locales/en/HotkeysPanel.json?hash=124bf90308ce697734c1890df4df1ee7";